export default "__VITE_ASSET__5Kbpbi5j__"